import {useQuery} from "@apollo/client";
import {GetPages} from "./Page.js";

export function useGetPages(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetPages,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetPages']) ? data : previousData;
    const extracted = (holder) ? holder['GetPages'] : [];

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetPages(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetPages,
        variables
    });
    const extracted = data ? data['GetPages'] : [];
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
